import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../../api';
// 1. The "Library" function (CORRECTED for native fetch)
const fetchSpaceContent = async (folderId,section ) => {
  return await apiRequest(`/api/spacecontent/${folderId}/${section}`, {
    method: 'POST', // Explicitly set POST to match Flask
    body: JSON.stringify({}), // Send an empty object if no data is needed
  }); 
};

// CENTRAL TOP: Folders (scoped to Project + Section)
export const useSpaceContent = (folderId,section) => {
  return useQuery({
	    queryKey: ['spacecontent', folderId, section],
	    queryFn: () => fetchSpaceContent({ folderId,section }),
	    enabled: !!section && !!folderId,
  });
};